/**
 * Get url with prefix for products
 * @param {string} url - url
 * @return {string} prefix
 */
export const getProductURL = (url: string): string => `https://${process.env.NGINX_DOMAIN}/${url}`;
